import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { WebLink } from '@/components/functional/Link/WebLink';
import { ImageBase } from '@/components/ui/Image/ImageBase';
/**
 * サイドメニューにバナー表示をするためのコンポーネント
 * @param props
 * @returns
 */
export const SideMenuBanner = (props) => {
    const { alt = 'バナー画像', className = '', gtmSettings, linkClickEvent, linkTo, pcImageSrc, spImageSrc, } = props;
    return (_jsx("div", Object.assign({ className: clsx('inline-block h-[200px] hover:opacity-80', className) }, { children: _jsxs(WebLink, Object.assign({ onClick: linkClickEvent, to: linkTo }, gtmSettings, { children: [_jsx("div", Object.assign({ className: clsx('h-full', 'hidden lg:block') }, { children: _jsx(ImageBase, { alt: alt, objectPosition: 'contain', src: pcImageSrc }) })), _jsx("div", Object.assign({ className: clsx('h-full', 'text-center', 'block lg:hidden') }, { children: _jsx(ImageBase, { alt: alt, objectPosition: 'contain', src: spImageSrc }) }))] })) })));
};
